import React from 'react'

import ModelsGroupsListContainer from './ModelsGroupsListContainer'

const ModelsGroupsList = () => (
  <ModelsGroupsListContainer data-test="component-models-groups-list" />
)

export default ModelsGroupsList
